module.exports = __webpack_public_path__ + "img/notDonePic.1cced065.jpg";